/**
 * Icon Component
 * 
 * Unified icon system using SVG files from assets/icons
 * Usage: <Icon name="heart" className="w-5 h-5 text-red-500" />
 */

import { formatMessage, CONSOLE_MESSAGES } from '../constants';
import { ReactComponent as Heart } from '../assets/icons/heart.svg';
import { ReactComponent as HeartFilled } from '../assets/icons/heart-filled.svg';
import { ReactComponent as Eye } from '../assets/icons/eye.svg';
import { ReactComponent as EyeOff } from '../assets/icons/eye-off.svg';
import { ReactComponent as Clipboard } from '../assets/icons/clipboard.svg';
import { ReactComponent as Close } from '../assets/icons/close.svg';
import { ReactComponent as Check } from '../assets/icons/check.svg';
import { ReactComponent as ChevronLeft } from '../assets/icons/chevron-left.svg';
import { ReactComponent as ChevronRight } from '../assets/icons/chevron-right.svg';
import { ReactComponent as ChevronDown } from '../assets/icons/chevron-down.svg';
import { ReactComponent as Search } from '../assets/icons/search.svg';
import { ReactComponent as ArrowRight } from '../assets/icons/arrow-right.svg';
import { ReactComponent as Star } from '../assets/icons/star.svg';
import { ReactComponent as Share } from '../assets/icons/share.svg';
import { ReactComponent as InfoCircle } from '../assets/icons/info-circle.svg';
import { ReactComponent as ExclamationCircle } from '../assets/icons/exclamation-circle.svg';
import { ReactComponent as WarningTriangle } from '../assets/icons/warning-triangle.svg';
import { ReactComponent as WarningFilled } from '../assets/icons/warning-filled.svg';
import { ReactComponent as Logout } from '../assets/icons/logout.svg';
import { ReactComponent as Film } from '../assets/icons/film.svg';
import { ReactComponent as Play } from '../assets/icons/play.svg';
import { ReactComponent as Lightbulb } from '../assets/icons/lightbulb.svg';
import { ReactComponent as Clock } from '../assets/icons/clock.svg';
import { ReactComponent as Filter } from '../assets/icons/filter.svg';
import { ReactComponent as Document } from '../assets/icons/document.svg';
import { ReactComponent as Key } from '../assets/icons/key.svg';

const icons = {
  heart: Heart,
  'heart-filled': HeartFilled,
  eye: Eye,
  'eye-off': EyeOff,
  clipboard: Clipboard,
  close: Close,
  check: Check,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-down': ChevronDown,
  search: Search,
  'arrow-right': ArrowRight,
  star: Star,
  share: Share,
  'info-circle': InfoCircle,
  'exclamation-circle': ExclamationCircle,
  'warning-triangle': WarningTriangle,
  'warning-filled': WarningFilled,
  logout: Logout,
  film: Film,
  play: Play,
  lightbulb: Lightbulb,
  clock: Clock,
  filter: Filter,
  document: Document,
  key: Key,
};

function Icon({ name, className = '', ...props }) {
  const IconComponent = icons[name];
  
  if (!IconComponent) {
    console.warn(formatMessage(CONSOLE_MESSAGES.ICON_NOT_FOUND, { name }));
    return null;
  }
  
  return <IconComponent className={className} {...props} />;
}

export default Icon;
